import React, { Component } from 'react';

const columnsOrgign = [
    {
        title: '任务ID',
        dataIndex: 'task_id',
        width: 80
    },
    {
        title: '任务名',
        dataIndex: 'name',
        width: 250
    },
    {
        title: '创建时间',
        dataIndex: 'create_time',
        width: 120,
        render: (text, record, index) => {
            return <div>
                <div style={{textAlign:'center',display:'inline-block'}}>
                    <div>{record.create_time.slice(0,10)}</div>
                    <div>{record.create_time.slice(10)}</div>
                </div>
            </div>
        }
    },
    {
        title: '题目起止时间',
        dataIndex: 'question_time',
        width: 120,
        render: (text, record, index) => {
            return <div>
                <div style={{textAlign:'center',display:'inline-block'}}>
                    <div>{record.question_start_time.slice(0,10)}</div>
                    <div>{record.question_end_time.slice(0,10)}</div>
                </div>
            </div>
        }
    },
    {
        title: '题数/已选',
        dataIndex: 'question_count',
        width: 100,
        render: (text, record, index) => {
            return <span>
                {record.question_count}/ {record.question_count_select}
            </span>
        }
    },
    {
        title: '修改通过/未修改通过/打回/坏题',
        dataIndex: 'question_status',
        width: 260,
        render: (text, record, index) => {
            return <span>
                {record.question_count_checkmodify||'--'} / {record.question_count_checkpass||'--'} / {record.question_count_checkrework||'--'} / {record.question_count_bad||'--'}
            </span>
        }
    },
    {
        title: '状态',
        dataIndex: 'stage_name',
        width: 70
    },


    {
        title: '打标签人',
        dataIndex: 'select_user_name',
        width: 80
    },
    {
        title: '审核人',
        dataIndex: 'check_user_name',
        width: 80
    },
    {
        title: '入库时间',
        dataIndex: 'storage_time',
        key: 'storage_time',
        width:160,
        render: (text, record, index) => {
            return <span>
                <div style={{textAlign:'center',display:'inline-block'}}>
                    <div>{record.storage_time&&record.storage_time.slice(0,10)}</div>
                    <div>{record.storage_time&&record.storage_time.slice(10)}</div>
                </div>
            </span>
        }
    },
    {
        title: '上线时间',
        dataIndex: 'online_time',
        width: 160,
        render: (text, record, index) => {
            return <span>
                <div style={{textAlign:'center',display:'inline-block'}}>
                    <div>{record.online_time&&record.online_time.slice(0,10)}</div>
                    <div>{record.online_time&&record.online_time.slice(10)}</div>
                </div>
            </span>
        }
    },
];
export {columnsOrgign}


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/tag_task_list/columns.js